import { useQuery } from '@tanstack/react-query';
import { useErrorToast } from '@/components/layers/ReactQueryProvider';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import type { IncidentsDateTimeRange } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const QUERY_KEY_INCIDENTS_DATE_TIME_RANGE = 'incidents-date-time-range';

type QueryParams = {
  enabled?: boolean;
};

export const useIncidentsDateTimeData = ({ enabled = true }: QueryParams = {}) => {
  const { orgId } = useCurrentUser();
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENTS_DATE_TIME_RANGE, orgId],
    queryFn: () => Api.incidents.getIncidentsDateTimeRange(),
    placeholderData: { min: null, max: null } as IncidentsDateTimeRange,
    enabled,
  });

  useErrorToast(query);

  return {
    data,
    incidentsDateTimeRange: data ?? { min: null, max: null },
    ...query,
  };
};
